
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career-services",
      function () {
        return require("private-next-pages/career-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career-services"])
      });
    }
  